import React, { useState, useEffect } from 'react';
import './Header.css';
import './Buttons.css';
import EmailVerification from './EmailVerification';
import { subscribeUserToPush, urlBase64ToUint8Array } from './utils';
import api from '../api';
import GardenerPolicy, { POLICY_TEXT } from './Utilities/GardenerPolicy';

const Header = ({ currentTab, handleTabChange, handleLogout, handleGenerateReport, currentGardener, setCurrentGardener, isDemoMode, handleCancelDemo, isNewUserMode, setIsLockedOutMode, fetchCurrentGardener}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [showSubscriptionPolicy, setShowSubscriptionPolicy] = useState(false);
    const [policyAgreed, setPolicyAgreed] = useState(false);
    const [sub, setSub] = useState(null);
    const [showEmailVerification, setShowEmailVerification] = useState(false);
    const [emailVerificationMessage, setEmailVerificationMessage] = useState("");


    const isPaidActive = sub?.subscriptionType === 'paid' && sub?.status === 'active';
    const isTrialing = sub?.subscriptionType === 'trial';
    const isPastDue = sub?.status === 'past_due';
    const isCanceled = sub?.status === 'canceled';

    const isLockedOutMode =
        isCanceled ||
        isPastDue ||
        (isTrialing && sub?.daysRemaining <= 0);

    //hide everything to do with subscription until free trial has ended or subscribed
    const isInFreeTrial = isTrialing && sub?.daysRemaining > 0;


    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    useEffect(() => {
        setIsLockedOutMode(isLockedOutMode);
    }, [isLockedOutMode, setIsLockedOutMode]);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const updateMobile = (e) => setIsMobile(e.matches);

        setIsMobile(mediaQuery.matches);
        mediaQuery.addEventListener('change', updateMobile);

        return () => mediaQuery.removeEventListener('change', updateMobile);
    }, []);


useEffect(() => {
    async function loadSubscription() {
        try {
            const res = await api.get('/stripeSubscription/me');
            setSub(res.data);
        } catch (err) {
            console.error("Failed to load subscription:", err);
        }
    }
    loadSubscription();
}, []);

const handleUpdateCard = async () => {
    try {
        const res = await api.post('/stripeSubscription/update-card');
        if (res.data?.url) {
            window.location.href = res.data.url;
        }
    } catch (err) {
        console.error("Update card error:", err);
        alert("Unable to open card update page.");
    }
};

const handleUpgrade = () => {
    setShowSubscriptionPolicy(true);
};



    const getDemoButtonLabel = () => {
        const level = currentGardener?.experienceLevel;

        if (!level) return "Explore with Jordan (Demo)"; // before login or unknown

        switch (level.toLowerCase()) {
            case "beginner":
                return "Learn with Jordan (All-Year Gardener)";
            case "intermediate":
                return "Grow with Jordan (All-Year Gardener)";
            case "seasoned":
            case "advanced":
                return "Compare with Jordan (Demo)";
            default:
                return "Explore with Jordan (Demo)";
        }
    };


    const tabs = [
        'Home',
        'Season Planner',
        'Garden Journal',
        'Orders',
        'Preserve',
    ];
    if (currentGardener?.isAdmin) {
  tabs.push('Admin');
}
return (
   <>
      <div className="header-wrapper">

         {isDemoMode && (
            <div className="demo-banner">
               {currentGardener?.experienceLevel?.toLowerCase() === 'beginner' && (
                  <>You're in demo mode - Learn year-round gardening from Jordan! See what Jordan is growing.</>
               )}
               {currentGardener?.experienceLevel?.toLowerCase() === 'intermediate' && (
                  <>You're in demo mode - Get seasonal tips from Jordan! See what Jordan is growing and optimize your current season.</>
               )}
               {(currentGardener?.experienceLevel?.toLowerCase() === 'seasoned' || currentGardener?.experienceLevel?.toLowerCase() === 'advanced') && (
                   <>You're in demo mode - data is simulated and won't be saved.</>
               )}
               <button className="button" onClick={handleCancelDemo}>Exit Demo</button>
            </div>
         )}

         <div className="header">

            <div className="header-title">
                <img src="/icons/logo-192.png" alt="Grow Your Food logo" className="header-logo" />
                </div>
                {!isLockedOutMode && (
                    <div className="header-center-top">
                        <span className="header-app-title">Your Garden Concierge</span>

                        {!isInFreeTrial && (
                        <div className="subscription-status-block">

                            {isPaidActive && (
                                <div className="status-pill active">Active</div>
                            )}

                            {!isPaidActive && (
                                <>
                                    {isPastDue && (
                                        <>
                                            <div className="status-pill past-due">Payment Failed</div>
                                            <button className="button small" onClick={handleUpdateCard}>Update Card</button>
                                        </>
                                    )}

                                    {isTrialing && (
                                        <>
                                            <div className="status-pill trial">
                                                Trial: {sub.daysRemaining} days left
                                            </div>
                                            <button
                                                className="button small"
                                                onClick={() => {
                                                    if (isNewUserMode) {
                                                        alert("Please finish onboarding first.");
                                                        return;
                                                    }

                                                    
                                                    // ----------------------------------------------------
                                                    // EMAIL VERIFICATION GATE (correct location)
                                                    // ----------------------------------------------------
                                                    if (currentGardener.emailVerified === false || currentGardener.emailVerified === 0) {
                                                        setEmailVerificationMessage("You must verify your email before upgrading your subscription. We need a valid email to send billing and subscription updates.");
                                                        setShowEmailVerification(true);
                                                        return;
                                                    }


                                                    handleUpgrade()
                                                }}
                                            >
                                                Subscribe
                                            </button>
                                        </>
                                    )}

                                    {isCanceled && (
                                        <>
                                            <div className="status-pill canceled">Subscription ended</div>
                                            <button
                                                className="button small"
                                                onClick={() => {
                                                    if (isNewUserMode) {
                                                        alert("Please finish onboarding first.");
                                                        return;
                                                    }
                                                    handleUpgrade()
                                                }}
                                            >
                                                Subscribe
                                            </button>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    )}

                                    {isInFreeTrial && (
                                        <button
                                            className="button small"
                                            onClick={() => {
                                                if (isNewUserMode) {
                                                    alert("Please finish onboarding first.");
                                                    return;
                                                }

                                                if (!currentGardener.emailVerified) {
                                                    setEmailVerificationMessage(
                                                        "You must verify your email before subscribing."
                                                    );
                                                    setShowEmailVerification(true);
                                                    return;
                                                }

                                                handleUpgrade();
                                            }}
                                        >
                                            Subscribe
                                        </button>
                                    )}


                    </div>
                )}

        {showEmailVerification && (
    <div className="cart-overlay">
        <EmailVerification
            gardener={currentGardener}
            message={emailVerificationMessage}
            onClose={() => setShowEmailVerification(false)}
            onVerified={async () => {
                await fetchCurrentGardener();
            }}
        />
    </div>
)}


                {isMobile && (
                    <div className="mobile-nav-row">
                        <div className="tabs">
                            <select
                                className="tabs-dropdown"
                                value={currentTab}
                                onChange={(e) => {
                                    if (isNewUserMode) {
                                        alert("Please finish onboarding first.");
                                        return;
                                    }
                                    if (sub?.status === 'canceled' ||
                                        (sub?.subscriptionType === 'trial' && sub?.daysRemaining <= 0)) {
                                        alert("Your trial has ended. Please subscribe to continue.");
                                        return;
                                    }
                                    handleTabChange(e.target.value);
                                }}
                            >
                                {tabs.map((tab) => (
                                    <option key={tab} value={tab}>
                                        {tab}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="header-buttons">
                            <button className="button" onClick={handleLogout}>Logout</button>
                        </div>
                    </div>
                )}


                    {/* SUBSCRIPTION LOCKOUT */}
                    {sub && (
                        <>
                            {(sub.status === 'canceled' ||
                            (sub.subscriptionType === 'trial' && sub.daysRemaining <= 0)) && (
                            <div className="header-center-top lockout-wrapper">
                                    <div className="subscription-lockout-banner">
                                        <p>Your trial has ended. Subscribe to continue using GrowYourFoodApp.</p>
                                        <button className="button" onClick={handleUpgrade}>
                                            Subscribe Now
                                        </button>
                                </div>
                                    </div>
                                )}
                        </>
                    )}

                <div className="header-center-bottom">
                    {!isMobile && (
                        <div className="tabs">
                            {tabs.map((tab) => (
                            <div
                                key={tab}
                                className={`tab ${currentTab === tab ? 'active' : ''}`}
                                onClick={() => {
                                    if (isNewUserMode) {
                                        alert("Please finish onboarding first.");
                                        return;
                                    }

                                    if (sub?.status === 'canceled' ||
                                        (sub?.subscriptionType === 'trial' && sub?.daysRemaining <= 0)) {
                                        alert("Your trial has ended. Please subscribe to continue.");
                                        return;
                                    }
                                    handleTabChange(tab);
                                }}
                            >
                                {tab}
                            </div>
                        ))}
                        </div>
                    )}
                </div>

                {!isMobile && (
                    <div className="header-buttons">

                        <button className="button" onClick={handleLogout}>Logout</button>

                    </div>
                )}
          </div>
       </div>

        {showSubscriptionPolicy && (
            <div className="modal-overlay">
              <div className="modal-content policy-step">
                <h3>Subscription Agreement</h3>
                <p className="helper-text">
                    Please review and agree to the Subscription Agreement before continuing.
                </p>

                <div className="policy-box">
                    <GardenerPolicy />
                </div>

                {!policyAgreed && (
                    <button
                        type="button"
                        className="button agree-button"
                        onClick={async () => {
                            try {
                                await api.post('/stripeSubscription/policy-agree', {
                                    policyVersion: "2026-04",
                                    policyText: POLICY_TEXT
                                });
                                setPolicyAgreed(true);
                            } catch (err) {
                                console.error('Failed to save policy agreement:', err);
                                alert('Could not save agreement.');
                            }
                        }}
                    >
                        I Agree to the Subscription Agreement
                    </button>
                )}

                {policyAgreed && (
                    <div className="stripe-section">
                        <h3>Secure Payment Setup</h3>
                        <p>
                            Your subscription will be billed monthly through Stripe.
                            Your payment method will also be used for optional preorders.
                        </p>

                        <button
                            type="button"
                            className="button"
                            onClick={async () => {
                                try {
                                    const res = await api.post('/stripeSubscription/subscribe');
                                    if (res.data?.url) {
                                        window.location.href = res.data.url;
                                    }
                                } catch (err) {
                                    console.error("Subscription error:", err);
                                    alert("Unable to start subscription process.");
                                }
                            }}
                        >
                            Continue to Secure Payment
                        </button>
                    </div>
                )}
            </div>
          </div>
        )}


        </>
    );
};

export default Header;
